import { render, staticRenderFns } from "./ModalInvoiceView.vue?vue&type=template&id=4f654164&scoped=true&"
import script from "./ModalInvoiceView.vue?vue&type=script&lang=js&"
export * from "./ModalInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./ModalInvoiceView.vue?vue&type=style&index=0&id=4f654164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f654164",
  null
  
)

export default component.exports